import { DEFAULT_FILTERS, type FilterState } from './filterTypes';

/**
 * Returns `filters` with one active selection removed: a single `value` is
 * dropped from a multi-select category, otherwise the whole category resets to
 * its default.
 *
 * Shared by the filter providers' `removeFilter` and the SRP zero-results
 * probes, so the count shown on a removable chip describes exactly the filter
 * set that clicking it produces.
 */
export function applyFilterRemoval(filters: FilterState, key: keyof FilterState, value?: string): FilterState {
  const next = { ...filters };

  if (value !== undefined) {
    const current = next[key];
    if (Array.isArray(current)) {
      (next as Record<string, unknown>)[key] = (current as Array<string>).filter((entry) => entry !== value);
    }
    return next;
  }

  (next as Record<string, unknown>)[key] = DEFAULT_FILTERS[key];
  return next;
}
